// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1JxxG","icon":"SortAdornment_icon__1WAIA","up":"SortAdornment_up__3NEQJ","down":"SortAdornment_down__3fq5n","active":"SortAdornment_active__e8NvD"};